import React, { FunctionComponent } from 'react'

import { PageLayout } from '../components/PageLayout/PageLayout'
import { PropertyDetailDrawer } from '../components/PropertyDetailDrawer/PropertyDetailDrawer'
import { PropertyListTable } from '../components/PropertyListTable/PropertyListTable'

export const PropertyList: FunctionComponent = () => {
  return (
    <>
      <PageLayout title="Seznamy nemovitostí">
        <PropertyListTable />
      </PageLayout>
      <PropertyDetailDrawer />
    </>
  )
}

export default PropertyList
